// Template tindakan kebidanan per fase — static data
// Berdasarkan form sample RM.RI.19.08.00

interface TindakanTemplate {
  kode: string;
  nama: string;
}

export const TEMPLATE_TINDAKAN: Record<string, TindakanTemplate[]> = {
  kala1_laten: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "periksa_dalam", nama: "Melakukan periksa dalam" },
    { kode: "observasi_his", nama: "Mengobservasi his" },
    { kode: "observasi_djj", nama: "Mengobservasi DJJ" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "terapi_musik", nama: "Melakukan terapi musik" },
    { kode: "gym_ball", nama: "Melakukan terapi gym ball" },
    { kode: "nst", nama: "Melakukan pemeriksaan NST" },
    { kode: "cst", nama: "Melakukan pemeriksaan CST" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  kala1_aktif: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "periksa_dalam", nama: "Melakukan periksa dalam" },
    { kode: "observasi_his", nama: "Mengobservasi his" },
    { kode: "observasi_djj", nama: "Mengobservasi DJJ" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "terapi_musik", nama: "Melakukan terapi musik" },
    { kode: "gym_ball", nama: "Melakukan terapi gym ball" },
    { kode: "nst", nama: "Melakukan pemeriksaan NST" },
    { kode: "cst", nama: "Melakukan pemeriksaan CST" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  kala2: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "periksa_dalam", nama: "Melakukan periksa dalam" },
    { kode: "teknik_mengejan", nama: "Mengajari tehnik mengejan" },
    { kode: "pimpin_persalinan", nama: "Memimpin persalinan, bayi lahir jam…JK…. BBL…../…./…./…./…./ A/S…." },
    { kode: "suntik_oksitosin", nama: "Menyuntik oksitosin, jam…." },
    { kode: "potong_tali_pusat", nama: "Memotong tali pusat" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  kala3: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "penegangan_tali_pusat", nama: "Melakukan penegangan tali pusat terkendali" },
    { kode: "lahirkan_plasenta", nama: "Melahirkan plasenta, plasenta lahir spontan kesan lengkap/ tidak" },
    { kode: "eksplorasi", nama: "Melakukan eksplorasi, kesan…. plasenta belum lahir 15 menit" },
    { kode: "suntik_oksitosin_2", nama: "Menyuntik oksitosin ke 2" },
    { kode: "fasilitasi_imd", nama: "Memfasilitasi IMD" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  kala4: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "pasang_iud", nama: "Memasang KB IUD" },
    { kode: "suntik_metergin", nama: "Menyuntik metergin" },
    { kode: "jahit_perineum", nama: "Menjahit perineum, ruptur grade….." },
    { kode: "observasi_bahaya_nifas", nama: "Mengobservasi tanda bahaya nifas" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  // ===== Tambahan diagnosa ref desk-review 20-06-2026 (IMP-054/058/060/061/078) =====

  belum_dalam_persalinan: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "observasi_his", nama: "Mengobservasi his" },
    { kode: "observasi_djj", nama: "Mengobservasi DJJ" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_perdarahan", nama: "Mengobservasi perdarahan" },
    { kode: "berikan_oksigen", nama: "Memberikan oksigen ……, …l/mnt" },
    { kode: "pasang_infus", nama: "Memasang infus" },
    { kode: "pasang_dc", nama: "Memasang dower catheter" },
    { kode: "periksa_dalam", nama: "Melakukan periksa dalam" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "balance_cairan", nama: "Melakukan balance cairan" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" }
  ],

  post_sc: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri_relaksasi", nama: "Mengkaji skala nyeri dan teknik relaksasi" },
    { kode: "observasi_kontraksi", nama: "Mengobservasi kontraksi uterus" },
    { kode: "observasi_perdarahan", nama: "Mengobservasi perdarahan / lochea" },
    { kode: "observasi_bak", nama: "Mengobservasi buang air kecil" },
    { kode: "observasi_asi", nama: "Mengobservasi produksi ASI" },
    { kode: "memerah_asi", nama: "Mengajarkan teknik memerah ASI" },
    { kode: "teknik_menyusui", nama: "Melatih teknik menyusui yang benar" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "perawatan_luka", nama: "Melakukan perawatan luka post SC" },
    { kode: "mobilisasi", nama: "Melatih mobilisasi bertahap" },
    { kode: "balance_cairan", nama: "Melakukan balance cairan" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" }
  ],

  post_partum_pervaginam: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri_relaksasi", nama: "Mengkaji skala nyeri dan teknik relaksasi" },
    { kode: "observasi_kontraksi", nama: "Mengobservasi kontraksi uterus" },
    { kode: "observasi_perdarahan", nama: "Mengobservasi perdarahan / lochea" },
    { kode: "observasi_bak", nama: "Mengobservasi buang air kecil" },
    { kode: "pelepasan_infus", nama: "Melepaskan infus" },
    { kode: "pelepasan_dc", nama: "Melepaskan dower catheter" },
    { kode: "perawatan_perineum", nama: "Melakukan perawatan perineum" },
    { kode: "pasang_kontrasepsi", nama: "Memasang alat kontrasepsi" },
    { kode: "residu_urin", nama: "Melakukan pemeriksaan residu urin" },
    { kode: "kegel_exercise", nama: "Melatih kegel exercise" },
    { kode: "bladder_training", nama: "Melakukan bladder training" },
    { kode: "observasi_asi", nama: "Mengobservasi produksi ASI" },
    { kode: "memerah_asi", nama: "Mengajarkan teknik memerah ASI" },
    { kode: "teknik_menyusui", nama: "Melatih teknik menyusui yang benar" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" }
  ],

  post_vakum: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri_relaksasi", nama: "Mengkaji skala nyeri dan teknik relaksasi" },
    { kode: "observasi_kontraksi", nama: "Mengobservasi kontraksi uterus" },
    { kode: "observasi_perdarahan", nama: "Mengobservasi perdarahan / lochea" },
    { kode: "observasi_bak", nama: "Mengobservasi buang air kecil" },
    { kode: "perawatan_perineum", nama: "Melakukan perawatan perineum" },
    { kode: "pasang_kontrasepsi", nama: "Memasang alat kontrasepsi" },
    { kode: "pelepasan_infus", nama: "Melepaskan infus" },
    { kode: "pelepasan_dc", nama: "Melepaskan dower catheter" },
    { kode: "residu_urin", nama: "Melakukan pemeriksaan residu urin" },
    { kode: "kegel_exercise", nama: "Melatih kegel exercise" },
    { kode: "bladder_training", nama: "Melakukan bladder training" },
    { kode: "observasi_asi", nama: "Mengobservasi produksi ASI" },
    { kode: "memerah_asi", nama: "Mengajarkan teknik memerah ASI" },
    { kode: "teknik_menyusui", nama: "Melatih teknik menyusui yang benar" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" }
  ],

  gyn: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "balance_cairan", nama: "Melakukan balance cairan" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_perdarahan_jl", nama: "Mengobservasi perdarahan dari jalan lahir" },
    { kode: "pasang_infus", nama: "Memasang infus" },
    { kode: "transfusi", nama: "Memasang transfusi darah" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "mobilisasi", nama: "Melatih mobilisasi bertahap" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  abortus_iminen: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_perdarahan_jl", nama: "Mengobservasi perdarahan dari jalan lahir" },
    { kode: "observasi_ekspulsi", nama: "Mengobservasi tanda-tanda ekspulsi jaringan" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "batasi_mobilisasi", nama: "Membatasi mobilisasi / bedrest" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  abortus_incomplete: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_perdarahan_jl", nama: "Mengobservasi perdarahan dari jalan lahir" },
    { kode: "ekspulsi_sisa", nama: "Mengevakuasi ekspulsi sisa jaringan" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  abortus_insipien: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_perdarahan_jl", nama: "Mengobservasi perdarahan dari jalan lahir" },
    { kode: "awasi_syok", nama: "Mengawasi tanda syok" },
    { kode: "pasang_iv", nama: "Memasang IV cath" },
    { kode: "ekspulsi_jaringan", nama: "Melakukan evakuasi ekspulsi jaringan" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  blighted_ovum: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_perdarahan_jl", nama: "Mengobservasi perdarahan dari jalan lahir" },
    { kode: "pasang_iv", nama: "Memasang IV cath" },
    { kode: "ekspulsi_jaringan", nama: "Melakukan ekspulsi jaringan" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  abortus_complete: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_perdarahan_jl", nama: "Mengobservasi perdarahan dari jalan lahir" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  hiperemesis: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "motivasi_nutrisi", nama: "Memotivasi pemenuhan nutrisi" },
    { kode: "observasi_mual_muntah", nama: "Mengobservasi mual muntah" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" }
  ],

  pprom: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "observasi_his", nama: "Mengobservasi his" },
    { kode: "observasi_djj", nama: "Mengobservasi DJJ" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_air_ketuban", nama: "Mengobservasi output air ketuban" },
    { kode: "berikan_oksigen", nama: "Memberikan oksigen ……, 3 L/menit" },
    { kode: "periksa_dalam", nama: "Melakukan periksa dalam" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" }
  ],

  partus_prematurus_iminen: [
    { kode: "informasi_hasil", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan kepada pasien" },
    { kode: "ukur_ttv", nama: "Mengukur TD, nadi, pernafasan, suhu" },
    { kode: "observasi_his", nama: "Mengobservasi his" },
    { kode: "observasi_djj", nama: "Mengobservasi DJJ" },
    { kode: "kaji_nyeri", nama: "Mengkaji skala nyeri" },
    { kode: "relaksasi_nafas", nama: "Mengajarkan teknik relaksasi nafas dalam" },
    { kode: "observasi_perdarahan", nama: "Mengobservasi perdarahan" },
    { kode: "berikan_oksigen", nama: "Memberikan oksigen ……, 3 L/menit" },
    { kode: "periksa_dalam", nama: "Melakukan periksa dalam" },
    { kode: "personal_hygiene", nama: "Memfasilitasi personal hygiene" },
    { kode: "upaya_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" },
    { kode: "kolaborasi_spog", nama: "Melakukan kolaborasi dengan dr. Sp.OG" }
  ],

  // ===== Catatan Kebidanan Bayi (IMP-070/071, ref 2_CATATAN_KEBIDANAN_BAYI) =====

  bayi_cukup_bulan: [
    { kode: "bayi_informasi", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan" },
    { kode: "bayi_ttv", nama: "Melakukan pemeriksaan tanda vital bayi" },
    { kode: "bayi_asi", nama: "Mengecek cara pemberian ASI dan memastikan bayi menyusu dengan baik" },
    { kode: "bayi_menyusui_football", nama: "Melatih teknik menyusui football hold" },
    { kode: "bayi_bak_bab", nama: "Mengobservasi bayi BAK dan BAB (meconium)" },
    { kode: "bayi_skrining_hipotiroid", nama: "Melakukan skrining hipotiroid bayi (SHK)" },
    { kode: "bayi_skrining_pjb", nama: "Melakukan skrining penyakit jantung bawaan (CCHD)" },
    { kode: "bayi_mandi", nama: "Memandikan bayi" },
    { kode: "bayi_tali_pusat", nama: "Melakukan perawatan tali pusat" },
    { kode: "bayi_hipotermi", nama: "Melakukan pencegahan hipotermi" },
    { kode: "bayi_gds", nama: "Melakukan pemeriksaan GDS bayi" },
    { kode: "bayi_bb", nama: "Mengukur berat badan bayi" },
    { kode: "bayi_hb0", nama: "Memberikan imunisasi Hepatitis B 0" },
    { kode: "bayi_hbig", nama: "Memberikan imunisasi HBIG" },
    { kode: "bayi_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" },
    { kode: "bayi_kmc", nama: "Melatih KMC dan memastikan bayi sudah dilakukan KMC" },
    { kode: "bayi_kolaborasi_spa", nama: "Melakukan kolaborasi dengan dokter Spesialis Anak" }
  ],

  bayi_kurang_bulan: [
    { kode: "bayi_informasi", nama: "Menginformasikan hasil pemeriksaan dan rencana asuhan" },
    { kode: "bayi_ttv", nama: "Melakukan pemeriksaan tanda vital bayi" },
    { kode: "bayi_asi", nama: "Mengecek cara pemberian ASI dan memastikan bayi menyusu dengan baik" },
    { kode: "bayi_menyusui_football", nama: "Melatih teknik menyusui football hold" },
    { kode: "bayi_bak_bab", nama: "Mengobservasi bayi BAK dan BAB (meconium)" },
    { kode: "bayi_skrining_hipotiroid", nama: "Melakukan skrining hipotiroid bayi (SHK)" },
    { kode: "bayi_skrining_pjb", nama: "Melakukan skrining penyakit jantung bawaan (CCHD)" },
    { kode: "bayi_mandi", nama: "Memandikan bayi" },
    { kode: "bayi_tali_pusat", nama: "Melakukan perawatan tali pusat" },
    { kode: "bayi_hipotermi", nama: "Melakukan pencegahan hipotermi" },
    { kode: "bayi_gds", nama: "Melakukan pemeriksaan GDS bayi" },
    { kode: "bayi_bb", nama: "Mengukur berat badan bayi" },
    { kode: "bayi_hb0", nama: "Memberikan imunisasi Hepatitis B 0" },
    { kode: "bayi_hbig", nama: "Memberikan imunisasi HBIG" },
    { kode: "bayi_risiko_jatuh", nama: "Melakukan upaya pencegahan risiko jatuh" },
    { kode: "bayi_kmc", nama: "Melatih KMC dan memastikan bayi sudah dilakukan KMC" },
    { kode: "bayi_kolaborasi_spa", nama: "Melakukan kolaborasi dengan dokter Spesialis Anak" }
  ]
};

// Template diagnosa pre-fill per fase
export const TEMPLATE_DIAGNOSA: Record<string, string> = {
  kala1_laten: "G..P..A..AH.. Hamil …mg dalam persalinan kala I fase laten dengan ….",
  kala1_aktif: "G..P..A..AH.. Hamil …mg dalam persalinan kala I fase aktif dengan ….",
  kala2: "G..P..A..AH.. Hamil …mg dalam persalinan kala II …..",
  kala3: "G..P..A..AH.. Hamil …mg dalam persalinan kala III",
  kala4: "G..P..A..AH.. Hamil …mg dalam persalinan kala IV",

  // Tambahan ref desk-review 20-06-2026
  belum_dalam_persalinan: "G…P…A…AH… Hamil … mg … hari belum dalam persalinan, dengan ……",
  post_sc: "P… A… AH… post sectio caesaria hari ke … dengan ……",
  post_partum_pervaginam: "P… A… AH… post partum pervaginam hari ke … dengan ……",
  post_vakum: "P… A… AH… post vakum ekstraksi hari ke … dengan ……",
  gyn: "P… A… AH… (kasus ginekologi) dengan ……",
  abortus_iminen: "G…P…A…AH… Hamil … mg dengan abortus iminen, dengan ……",
  abortus_incomplete: "G…P…A…AH… Hamil … mg dengan abortus incomplete, dengan ……",
  abortus_insipien: "G…P…A…AH… Hamil … mg abortus insipien, dengan ……",
  blighted_ovum: "G…P…A…AH… Hamil … mg blighted ovum, dengan ……",
  abortus_complete: "G…P…A…AH… Hamil … mg abortus complete, dengan ……",
  hiperemesis: "G…P…A…AH… Hamil … mg hiperemesis gravidarum, dengan ……",
  pprom: "G…P…A…AH… Hamil … mg PPROM … jam/hari, dengan ……",
  partus_prematurus_iminen: "G…P…A…AH… Hamil … mg partus prematurus iminen, dengan ……",
  bayi_cukup_bulan: "Bayi Baru Lahir Cukup Bulan dengan ……",
  bayi_kurang_bulan: "Bayi Baru Lahir Kurang Bulan dengan ……"
};
